import React from 'react';

const arrowSvg = () => {
  return (
    <svg version="1.1" className="arrow-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 25 35">
      <g>
        <rect className="arrow-rect" x="5" y="5" width="5" height="5"/>
      </g>
      <g>
        <rect className="arrow-rect" x="10" y="10" width="5" height="5"/>
      </g>
      <g>
        <rect className="arrow-rect" x="15" y="15" width="5" height="5"/>
      </g>
      <g>
        <rect className="arrow-rect" x="10" y="20" width="5" height="5"/>
      </g>
      <g>
        <rect className="arrow-rect" x="5" y="25" width="5" height="5"/>
      </g>
    </svg>
  )
}

export default arrowSvg;


// WEBPACK FOOTER //
// ./src/component/svg/arrow.js